<script>
  import {
    Breakpoint,
    Modal as DangerModal,
    OverflowMenu,
    OverflowMenuItem,
    TextInput,
  } from "carbon-components-svelte";

  //// imports
  import FlowPlotterSmall from "lib/components/FlowPlotterSmall.svelte";
  import download from "downloadjs";
  import { Loading } from "carbon-components-svelte";
  import { fetchWithSession } from "@utils/fetchWithSession.js";
  import { uiFeatureStore } from "@stores/uiFeatureStore.js";
  import { createRequestScope } from "lib/util/requestScope.js";
  import { damfilters } from "lib/stores.js";
  import { filtersConfigStore } from "@stores/damFiltersConfigStores.js";
  import { getApplicableFilters } from "@utils/getDamApplicableFilters.js";

  import Filter from "./components/filter/Filter.svelte";

  import { formatTimeDelta } from "lib/util/formatfunctions.js";

  // ui-elements
  import PaxbotChat from "lib/components/paxbot/PaxbotChat.svelte";

  // sidenav

  import { Accordion, SectionWrapper, Button } from "paxray-components-svelte";
  import AppSelection from "./components/appSelection.svelte";
  import Header from "lib/components/Header.svelte";

  import MatrixTable from "./components/MatrixTable.svelte";
  import AppDrilldownSourceMenu from "./components/AppDrilldownSourceMenu.svelte";
  import { onMount } from "svelte";
  import {
    ADD_ROAD_ICON,
    APPLICATIONS_ICON,
    APPOVERVIEW_ICON,
    BOT_ICON,
    BOT_WHITE_ICON,
    FULLSCREEN_ICON,
    FULLSCREEN_OFF_ICON,
    INTERACTIONS_ICON,
    SAVE_ICON,
    TIME_BEFORE_ICON,
    WINDOWS_ICON,
  } from "@utils/icons.js";

  // Requests der Maske enden, wenn die Maske verlassen wird.
  const abortSignal = createRequestScope();
  export let idproject;
  const { setCurrentView } = filtersConfigStore;

  let currentApp = "";
  let currentAppInformation = currentApp;
  let windowPartitionsLoading = false;

  let zoomLevel = 100;
  let applicationlist = [];
  let windowlist = [];
  let loading = true;
  let loadingApp = true;
  let selectedKPIindex = 0;
  let selectedSourceIndex = 0;
  let screenSize;

  let from;
  let to;
  let dataNew;
  let fullscreen = false;

  let disabledlevels = [3];
  let selectedLevel = 0;

  let napps = 3;
  let levelBefore = 1;
  let levelAfter = 1;
  let minFrequency = 0;

  let appGraphLoading = true;

  let disableModes = [2];
  let selectMode = 0;
  let firstLoad = true;
  let requestTimeout;
  const appGraphCache = new Map();
  const appGraphRequests = new Map();
  let buttonsDisabled = false;
  let view = "App Flow";

  let graph = { nodes: [], edges: [] };
  let drawSourceGraph = { nodes: [], edges: [] };
  let displayGraph = graph;
  let visibleGraphTotal = 0;
  let visibleGraphInteractions = { time: 0, mouseclicks: 0 };
  let selectedNodeData = {};
  let visibleAppShares = [];
  let quantificationOpen = true;
  let applicationsOpen = true;
  let drawMode = false;
  let drawingViewMode = false;
  let drawStartNode = "";
  let drawFocusNode = "";
  let drawConfirmedNodes = [];
  let drawConfirmedEdges = [];
  let drawingLoaded = false;
  let drawingsLoadedForProject = "";
  let savedDrawings = [];
  let drawingsPage = 0;
  let editingDrawingId = "";
  let editingDrawingName = "";
  let selectedDrawingId = "";
  let drawingSearchTerm = "";
  let lastDrawingScope = "";
  let activeDrawingScope = "";
  let deleteDrawingModalOpen = false;
  let drawingToDelete = null;
  let saveDrawingModalOpen = false;
  let pendingDrawingName = "";
  const drawingsPageSize = 5;

  let paxbotOpen = false;

  let flowPlotterRef;

  const levelLabels = {
    0: "Application Map",
    1: "App Inflow",
    2: "App Outflow",
    3: "Window Map",
  };
  const patternLabels = {
    0: "Transition Pattern",
    1: "Split Pattern",
    2: "Combined Pattern",
  };
  const paxbotStarterQuestions = [
    "What should I look at first?",
    "Explain this view.",
    "Which app transitions stand out?",
  ];

  $: setCurrentView(view);

  $: selectMode === 0 ? getWindowPartitions() : loadAppMatrix();

  $: currentAppInformation = !isNaN(currentApp)
    ? currentApp
    : currentApp.split("###")[0];

  $: currentApp = normalizeGraphNodeId(currentApp);
  $: selectedNodeData =
    (usesWindowSelection() ? windowlist : applicationlist).find(
      (app) =>
        app.id == currentAppInformation ||
        app?.windowtitle == currentAppInformation,
    ) || {};
  // Die Draw-Helfer lesen diesen Zustand intern. Ohne ihn hier sichtbar zu
  // machen, rechnet Svelte nach dem Entfernen eines Pfadknotens nicht neu.
  $: drawState = [
    drawMode,
    drawStartNode,
    drawFocusNode,
    drawConfirmedNodes,
    drawConfirmedEdges,
  ];
  $: displayGraph =
    drawState &&
    getFrequencyFilteredGraph(
      drawMode || drawingViewMode ? getDrawGraph(drawSourceGraph) : graph,
      minFrequency,
    );
  $: visibleGraphTotal = getGraphTotal(displayGraph);
  $: visibleGraphInteractions = getVisibleGraphInteractions(displayGraph);
  $: visibleAppShares = getVisibleAppShares(displayGraph);
  $: noDataForFilters =
    (!loadingApp && applicationlist.length === 0) ||
    (!appGraphLoading && graph.nodes.length === 0 && graph.edges.length === 0);
  $: drawCandidateEdges = drawState && getDrawCandidateEdges(drawSourceGraph);
  $: drawCandidateNodes = drawState && getDrawCandidateNodes(drawSourceGraph);
  $: activeDrawingScope = `appflow:${drawingScopeName(selectedLevel)}`;
  $: if (
    (drawMode || drawingViewMode) &&
    drawStartNode &&
    currentApp &&
    normalizeGraphNodeId(currentApp) !== normalizeGraphNodeId(drawStartNode)
  ) {
    clearDrawingState();
  }
  $: scopedDrawings = savedDrawings.filter(
    (drawing) => drawingScope(drawing) === activeDrawingScope,
  );
  $: visibleDrawings = scopedDrawings.filter((drawing) =>
    drawing.name.toLowerCase().includes(drawingSearchTerm.toLowerCase()),
  );
  $: if (lastDrawingScope !== activeDrawingScope) {
    lastDrawingScope = activeDrawingScope;
    drawingsPage = 0;
    editingDrawingId = "";
  }
  $: if (selectedDrawingId) {
    const selectedDrawing = savedDrawings.find(
      (drawing) => drawing.id === selectedDrawingId,
    );
    if (
      !selectedDrawing ||
      drawingScope(selectedDrawing) !== activeDrawingScope
    )
      clearDrawingState();
  }
  $: if (
    drawingsPage > 0 &&
    drawingsPage >= Math.ceil(visibleDrawings.length / drawingsPageSize)
  ) {
    drawingsPage = Math.max(
      0,
      Math.ceil(visibleDrawings.length / drawingsPageSize) - 1,
    );
  }
  $: pagedDrawings = visibleDrawings.slice(
    drawingsPage * drawingsPageSize,
    drawingsPage * drawingsPageSize + drawingsPageSize,
  );
  $: drawingsPages = Math.max(
    1,
    Math.ceil(visibleDrawings.length / drawingsPageSize),
  );

  $: {
    if (
      currentApp &&
      $damfilters &&
      selectedLevel >= 0 &&
      levelAfter >= 0 &&
      levelBefore >= 0 &&
      selectedKPIindex >= 0 &&
      selectedSourceIndex >= 0 &&
      napps >= 0 &&
      $filtersConfigStore.storeLoaded
    ) {
      if (firstLoad) {
        firstLoad = false;
        loadAppGraph(currentApp);
      } else
        delayedRequest(() => {
          loadAppGraph(currentApp);
          getWindowPartitions();
        });
    }
  }

  function handleDownload() {
    if (flowPlotterRef?.downloadSVG) {
      flowPlotterRef.downloadSVG(currentApp);
    }
  }

  // Plattform-Feature "Main: Window Titles & UI Elements": aus -> Hauptphase nur
  // Application Map; App Inflow, App Outflow und Window Map sind gesperrt.
  $: windowTitlesLocked =
    selectedSourceIndex === 1 &&
    !$uiFeatureStore.platformFeatures.mainWindowTitles;
  $: if (windowTitlesLocked && selectedLevel >= 1) {
    selectedLevel = 0;
    currentApp = applicationlist[0]?.id || "";
  }

  function usesWindowSelection() {
    return selectedLevel >= 2;
  }

  function selectionType() {
    return usesWindowSelection() ? "Window" : "App";
  }

  function dataSource() {
    return selectedSourceIndex === 1 ? "main" : "recordings";
  }

  function graphMode() {
    if (selectedLevel === 1) return "app_inflow";
    if (selectedLevel === 2) return "app_outflow";
    return "";
  }

  function currentDrawingScope() {
    return activeDrawingScope;
  }

  function drawingScope(drawing) {
    if (drawing.scope?.startsWith("appflow:")) return drawing.scope;
    if (drawing.scope?.startsWith("level:")) {
      const legacyLevel = Number(drawing.scope.split(":")[1]);
      return `appflow:${drawingScopeName(Number.isNaN(legacyLevel) ? 0 : legacyLevel)}`;
    }
    return `appflow:${drawingScopeName(drawing.selectedLevel ?? 0)}`;
  }

  function drawingScopeName(level) {
    if (level === 1) return "app-inflow";
    if (level === 2) return "app-outflow";
    if (level === 3) return "window-map";
    return "application-map";
  }

  function normalizeGraphNodeId(value) {
    if (!isNaN(value)) return value;
    const baseValue = String(value || "").split("###")[0];
    if (baseValue.startsWith("app::")) return baseValue.slice(5);
    if (baseValue.startsWith("win::")) return baseValue.slice(5);
    return baseValue;
  }

  function drawingsStorageKey() {
    return `paxray.appflow.drawings.${idproject}`;
  }

  function loadSavedDrawings() {
    if (!idproject || typeof localStorage === "undefined") return;
    try {
      savedDrawings = JSON.parse(
        localStorage.getItem(drawingsStorageKey()) || "[]",
      );
    } catch {
      savedDrawings = [];
    }
    drawingsLoadedForProject = idproject;
  }

  function persistDrawings() {
    if (typeof localStorage === "undefined") return;
    localStorage.setItem(drawingsStorageKey(), JSON.stringify(savedDrawings));
  }

  onMount(loadSavedDrawings);

  $: if (idproject && drawingsLoadedForProject !== idproject)
    loadSavedDrawings();

  function baseNode(id) {
    return String(id || "").split("###")[0];
  }

  function edgeKey(edge) {
    return edge.from + "->" + edge.to;
  }

  function drawEdgeKey(from, to) {
    return from + "->" + to;
  }

  function getNodeLabel(id) {
    const node =
      drawSourceGraph.nodes.find((node) => node.id === id) ||
      graph.nodes.find((node) => node.id === id) ||
      drawSourceGraph.nodes.find(
        (node) => baseNode(node.id) === baseNode(id),
      ) ||
      graph.nodes.find((node) => baseNode(node.id) === baseNode(id));
    return node?.label || baseNode(id);
  }

  function clearDrawingState() {
    drawMode = false;
    drawingViewMode = false;
    drawStartNode = "";
    drawFocusNode = "";
    drawConfirmedNodes = [];
    drawConfirmedEdges = [];
    drawSourceGraph = { nodes: [], edges: [] };
    drawingLoaded = false;
    selectedDrawingId = "";
  }

  function getDrawCandidateEdges(sourceGraph) {
    if (!drawMode || !drawConfirmedNodes.length) return [];
    const confirmedEdges = new Set(drawConfirmedEdges);
    const confirmedNodes = new Set(drawConfirmedNodes);
    const confirmedBaseNodes = new Set(
      drawConfirmedNodes.map(normalizeGraphNodeId),
    );
    const direction = getDrawNodeDirection(drawFocusNode);
    return (sourceGraph?.edges || []).filter((edge) => {
      const nextNode =
        direction === "after"
          ? edge.from === drawFocusNode
            ? edge.to
            : ""
          : direction === "before"
            ? edge.to === drawFocusNode
              ? edge.from
              : ""
            : edge.from === drawFocusNode
              ? edge.to
              : edge.to === drawFocusNode
                ? edge.from
                : "";
      return (
        nextNode &&
        !confirmedNodes.has(nextNode) &&
        !confirmedBaseNodes.has(normalizeGraphNodeId(nextNode)) &&
        !confirmedEdges.has(edgeKey(edge))
      );
    });
  }

  function getDrawNodeDirection(nodeId) {
    if (!nodeId || nodeId === drawStartNode) return "both";
    if (hasConfirmedPath(drawStartNode, nodeId)) return "after";
    if (hasConfirmedPath(nodeId, drawStartNode)) return "before";
    return "both";
  }

  function hasConfirmedPath(fromNode, toNode) {
    const edges = drawConfirmedEdges.map((key) => key.split("->"));
    const queue = [fromNode];
    const visited = new Set();
    while (queue.length) {
      const node = queue.shift();
      if (node === toNode) return true;
      if (visited.has(node)) continue;
      visited.add(node);
      edges.forEach(([from, to]) => {
        if (from === node && !visited.has(to)) queue.push(to);
      });
    }
    return false;
  }

  function getDrawCandidateNodes(sourceGraph) {
    const nodes = new Set();
    getDrawCandidateEdges(sourceGraph).forEach((edge) => {
      nodes.add(edge.from);
      nodes.add(edge.to);
    });
    return [...nodes].filter((node) => !drawConfirmedNodes.includes(node));
  }

  function getDrawGraph(sourceGraph) {
    const confirmedNodes = new Set(drawConfirmedNodes);
    const confirmedEdges = new Set(drawConfirmedEdges);
    const candidateEdges = getDrawCandidateEdges(sourceGraph);
    const candidateEdgeKeys = new Set(candidateEdges.map(edgeKey));
    const visibleNodes = new Set([...confirmedNodes]);
    candidateEdges.forEach((edge) => {
      visibleNodes.add(edge.from);
      visibleNodes.add(edge.to);
    });
    return {
      nodes: (sourceGraph?.nodes || []).filter((node) =>
        visibleNodes.has(node.id),
      ),
      edges: (sourceGraph?.edges || []).filter(
        (edge) =>
          confirmedEdges.has(edgeKey(edge)) ||
          candidateEdgeKeys.has(edgeKey(edge)),
      ),
    };
  }

  function getFrequencyFilteredGraph(sourceGraph, frequency) {
    const edges = sourceGraph?.edges || [];
    const threshold = Number(frequency) || 0;
    if (!threshold || edges.length === 0) return sourceGraph;
    const maxValue = Math.max(...edges.map((edge) => Number(edge.value) || 0));
    if (!maxValue) return sourceGraph;
    const filteredEdges = edges.filter(
      (edge) => ((Number(edge.value) || 0) / maxValue) * 100 >= threshold,
    );
    const visibleNodes = new Set();
    filteredEdges.forEach((edge) => {
      visibleNodes.add(edge.from);
      visibleNodes.add(edge.to);
    });
    drawConfirmedNodes.forEach((node) => visibleNodes.add(node));
    return {
      nodes: (sourceGraph?.nodes || []).filter((node) =>
        visibleNodes.has(node.id),
      ),
      edges: filteredEdges,
    };
  }

  function startDrawing() {
    const startNode = getCurrentGraphNodeId();
    if (!startNode) return;
    drawMode = true;
    drawingViewMode = false;
    drawStartNode = startNode;
    drawFocusNode = startNode;
    drawConfirmedNodes = [startNode];
    drawConfirmedEdges = [];
    drawSourceGraph = graph;
    drawingLoaded = false;
    fetchAppGraph(normalizeGraphNodeId(startNode), {
      stepsBefore: 1,
      stepsAfter: 1,
    }).then((data) => {
      if (drawMode && drawStartNode === startNode) {
        drawSourceGraph = mapDrawGraphToFocus(data, startNode);
      }
    });
  }

  function getCurrentGraphNodeId() {
    const current = normalizeGraphNodeId(currentAppInformation || currentApp);
    const candidates = graph.nodes.filter(
      (node) =>
        normalizeGraphNodeId(node.id) === current ||
        normalizeGraphNodeId(node.label) === current,
    );
    if (candidates.length > 0) {
      return candidates.sort((a, b) => {
        const scoreA =
          getIncidentEdgeCount(a.id) +
          (String(a.id).includes("###") ? 0 : 1000);
        const scoreB =
          getIncidentEdgeCount(b.id) +
          (String(b.id).includes("###") ? 0 : 1000);
        return scoreB - scoreA;
      })[0].id;
    }
    return current;
  }

  function getIncidentEdgeCount(nodeId) {
    return graph.edges.filter(
      (edge) => edge.from === nodeId || edge.to === nodeId,
    ).length;
  }

  function getNextFlowPathName() {
    const usedNumbers = savedDrawings
      .filter((drawing) => drawingScope(drawing) === currentDrawingScope())
      .map((drawing) => /^Flow Path (\d+)$/.exec(drawing.name)?.[1])
      .filter(Boolean)
      .map(Number);
    let index = 1;
    while (usedNumbers.includes(index)) index += 1;
    return `Flow Path ${index}`;
  }

  function openSaveDrawingModal() {
    if (!drawStartNode || drawConfirmedEdges.length === 0) {
      drawMode = false;
      drawingViewMode = false;
      return;
    }
    pendingDrawingName = getNextFlowPathName();
    saveDrawingModalOpen = true;
  }

  function confirmSaveDrawing() {
    saveDrawing(pendingDrawingName || getNextFlowPathName());
    saveDrawingModalOpen = false;
  }

  function saveDrawing(name) {
    const now = new Date().toISOString();
    const transitions = drawConfirmedEdges.map((key) => {
      const [from, to] = key.split("->");
      const edge = drawSourceGraph.edges.find((edge) => edgeKey(edge) === key);
      return {
        from,
        to,
        fromLabel: getNodeLabel(from),
        toLabel: getNodeLabel(to),
        value: edge?.value,
      };
    });
    const newDrawing = {
      id: now,
      projectId: idproject,
      scope: currentDrawingScope(),
      selectedLevel,
      name,
      startNode: drawStartNode,
      transitions,
      createdAt: now,
      updatedAt: now,
    };
    savedDrawings = [newDrawing, ...savedDrawings];
    persistDrawings();
    drawMode = false;
    drawingViewMode = true;
    drawSourceGraph = getStoredDrawingGraph(newDrawing);
    drawingLoaded = false;
    selectedDrawingId = newDrawing.id;
  }

  function toggleDrawing() {
    if (drawMode) openSaveDrawingModal();
    else if (drawingViewMode && drawConfirmedNodes.length) {
      drawMode = true;
      drawingViewMode = false;
      drawFocusNode =
        drawConfirmedNodes[drawConfirmedNodes.length - 1] || drawStartNode;
    } else startDrawing();
  }

  function trimDrawingAtNode(clickedNode) {
    const clickedIndex = drawConfirmedNodes.indexOf(clickedNode);
    if (clickedIndex <= 0) {
      drawConfirmedNodes = drawStartNode ? [drawStartNode] : [];
      drawConfirmedEdges = [];
      drawFocusNode = drawStartNode;
      return;
    }
    const remainingNodes = drawConfirmedNodes.slice(0, clickedIndex);
    const remainingNodeSet = new Set(remainingNodes);
    drawConfirmedNodes = remainingNodes;
    drawConfirmedEdges = drawConfirmedEdges.filter((key) => {
      const [from, to] = key.split("->");
      return remainingNodeSet.has(from) && remainingNodeSet.has(to);
    });
    drawFocusNode = remainingNodes[remainingNodes.length - 1] || drawStartNode;
  }

  function loadDrawOptionsForNode(nodeId) {
    drawFocusNode = nodeId;
    fetchAppGraph(normalizeGraphNodeId(nodeId), {
      ...drawFetchStepsForNode(nodeId),
      ...drawFetchOptionsForNode(nodeId),
    }).then((data) => {
      if (drawMode && drawFocusNode === nodeId) {
        drawSourceGraph = mergeGraphs(
          drawSourceGraph,
          mapDrawGraphToFocus(data, nodeId),
        );
      }
    });
  }

  function drawFetchStepsForNode(nodeId) {
    const direction = getDrawNodeDirection(nodeId);
    if (direction === "after") return { stepsBefore: 0, stepsAfter: 1 };
    if (direction === "before") return { stepsBefore: 1, stepsAfter: 0 };
    return { stepsBefore: 1, stepsAfter: 1 };
  }

  function drawFetchOptionsForNode(nodeId) {
    const nodeBase = baseNode(nodeId);
    if (nodeBase.startsWith("win::"))
      return { mode: "", useWindowSelection: true };
    if (nodeBase.startsWith("app::"))
      return { mode: "", useWindowSelection: false };
    return {};
  }

  function mapDrawGraphToFocus(sourceGraph, focusNodeId) {
    const focusBase = normalizeGraphNodeId(focusNodeId);
    const mapNodeId = (nodeId) => {
      const nodeBase = normalizeGraphNodeId(nodeId);
      if (nodeBase === focusBase && !String(nodeId).includes("###"))
        return focusNodeId;
      if (nodeId === focusNodeId) return nodeId;
      return `${nodeId}###via###${focusNodeId}`;
    };
    return {
      nodes: (sourceGraph?.nodes || []).map((node) => ({
        ...node,
        id: mapNodeId(node.id),
      })),
      edges: (sourceGraph?.edges || []).map((edge) => ({
        ...edge,
        from: mapNodeId(edge.from),
        to: mapNodeId(edge.to),
      })),
    };
  }

  function handleDrawNodeClick(event) {
    if (!drawMode) return;
    const clickedNode = event.detail.id;
    const confirmedNodes = new Set(drawConfirmedNodes);
    if (confirmedNodes.has(clickedNode)) {
      loadDrawOptionsForNode(clickedNode);
      return;
    }
    const candidateEdges = getDrawCandidateEdges(drawSourceGraph);
    const newEdge = candidateEdges.find((edge) => {
      return (
        (edge.from === clickedNode && edge.to === drawFocusNode) ||
        (edge.to === clickedNode && edge.from === drawFocusNode)
      );
    });

    if (!newEdge) return;
    drawConfirmedNodes = [...drawConfirmedNodes, clickedNode];
    drawConfirmedEdges = [...drawConfirmedEdges, edgeKey(newEdge)];
    loadDrawOptionsForNode(clickedNode);
  }

  function handleDrawNodeDelete(event) {
    if (!drawMode) return;
    trimDrawingAtNode(event.detail.id);
  }

  function loadDrawing(drawing) {
    if (drawingScope(drawing) !== currentDrawingScope()) return;
    drawMode = false;
    drawingViewMode = true;
    drawStartNode = drawing.startNode;
    drawFocusNode =
      drawing.transitions[drawing.transitions.length - 1]?.to ||
      drawing.startNode;
    drawConfirmedNodes = [
      drawing.startNode,
      ...drawing.transitions.flatMap((transition) => [
        transition.from,
        transition.to,
      ]),
    ].filter((node, index, nodes) => nodes.indexOf(node) === index);
    drawConfirmedEdges = drawing.transitions.map((transition) =>
      drawEdgeKey(transition.from, transition.to),
    );
    drawSourceGraph = getStoredDrawingGraph(drawing);
    drawingLoaded = true;
    selectedDrawingId = drawing.id;
    currentApp = normalizeGraphNodeId(drawing.startNode);
    loadAppGraph(normalizeGraphNodeId(drawing.startNode));
  }

  function getStoredDrawingGraph(drawing) {
    const nodes = new Map();
    const edges = [];
    const ensureNode = (id, label) => {
      if (!id || nodes.has(id)) return;
      const existing =
        drawSourceGraph.nodes.find((node) => node.id === id) ||
        graph.nodes.find((node) => node.id === id);
      nodes.set(id, {
        ...(existing || {}),
        id,
        shape: existing?.shape || "image",
        label: existing?.label || label || getNodeLabel(id),
      });
    };
    ensureNode(drawing.startNode, getNodeLabel(drawing.startNode));
    drawing.transitions.forEach((transition) => {
      ensureNode(transition.from, transition.fromLabel);
      ensureNode(transition.to, transition.toLabel);
      edges.push({
        from: transition.from,
        to: transition.to,
        value: transition.value,
      });
    });
    return { nodes: [...nodes.values()], edges };
  }

  function renameDrawing(drawing, name) {
    savedDrawings = savedDrawings.map((item) =>
      item.id === drawing.id
        ? { ...item, name, updatedAt: new Date().toISOString() }
        : item,
    );
    persistDrawings();
  }

  function startRenameDrawing(drawing) {
    editingDrawingId = drawing.id;
    editingDrawingName = drawing.name;
  }

  function saveRenameDrawing(drawing) {
    renameDrawing(drawing, editingDrawingName || drawing.name);
    editingDrawingId = "";
    editingDrawingName = "";
  }

  function openDeleteDrawingModal(drawing) {
    drawingToDelete = drawing;
    deleteDrawingModalOpen = true;
  }

  function deleteDrawing(drawing) {
    savedDrawings = savedDrawings.filter((item) => item.id !== drawing.id);
    if (selectedDrawingId === drawing.id) clearDrawingState();
    drawingsPage = Math.min(
      drawingsPage,
      Math.max(0, Math.ceil(visibleDrawings.length / drawingsPageSize) - 1),
    );
    persistDrawings();
  }

  function confirmDeleteDrawing() {
    if (drawingToDelete) deleteDrawing(drawingToDelete);
    deleteDrawingModalOpen = false;
    drawingToDelete = null;
  }

  function mergeGraphs(baseGraph, nextGraph) {
    const nodes = new Map(
      (baseGraph?.nodes || []).map((node) => [node.id, node]),
    );
    const edges = new Map(
      (baseGraph?.edges || []).map((edge) => [edgeKey(edge), edge]),
    );
    (nextGraph?.nodes || []).forEach((node) => nodes.set(node.id, node));
    (nextGraph?.edges || []).forEach((edge) => edges.set(edgeKey(edge), edge));
    return {
      nodes: [...nodes.values()],
      edges: [...edges.values()],
    };
  }

  function getVisibleAppShares(graph) {
    const nodes = graph?.nodes || [];
    const edges = graph?.edges || [];
    const labels = new Map(
      nodes.map((node) => [node.id, getApplicationLabelForNode(node)]),
    );
    const totals = {};
    edges.forEach((edge) => {
      const value = Number(edge.value) || 0;
      [edge.from, edge.to].forEach((nodeId) => {
        const label = labels.get(nodeId);
        if (label) totals[label] = (totals[label] || 0) + value;
      });
    });
    const total = Object.values(totals).reduce((sum, value) => sum + value, 0);
    if (!total) return [];
    return Object.entries(totals)
      .map(([clearname, value]) => ({ clearname, ratio: value / total }))
      .sort((a, b) => b.ratio - a.ratio)
      .slice(0, 5);
  }

  function getApplicationLabelForNode(node) {
    const label = node.label || node.id;
    if (selectedLevel === 0) return label;
    const windowItem = windowlist.find(
      (item) =>
        item.id == node.id ||
        item.id == label ||
        item.windowtitle == label ||
        `${item.clearname} - ${item.windowtitle}` == label,
    );
    return windowItem?.clearname || label;
  }

  function getGraphTotal(graph) {
    return (graph?.edges || []).reduce(
      (sum, edge) => sum + (Number(edge.value) || 0),
      0,
    );
  }

  function formatGraphTotal(value) {
    if (!value) return "-";
    return formatCompactNumber(value);
  }

  function formatCompactNumber(value) {
    const number = Number(value) || 0;
    if (Math.abs(number) >= 1000000)
      return `${(number / 1000000).toFixed(2)} M`;
    if (Math.abs(number) >= 1000) return `${(number / 1000).toFixed(1)} k`;
    return Math.round(number);
  }

  function formatPaxbotDuration(value) {
    return Number(value) > 0 ? formatTimeDelta(Number(value)) : "-";
  }

  function getPaxbotNodeLabel(nodeId) {
    const node = (displayGraph?.nodes || []).find((item) => item.id === nodeId);
    return node?.label || getNodeLabel(nodeId);
  }

  function getPaxbotContext() {
    const selectedDrawing = savedDrawings.find(
      (drawing) => drawing.id === selectedDrawingId,
    );
    return {
      page: "App Flow",
      projectId: idproject,
      source: dataSource(),
      level: levelLabels[selectedLevel],
      pattern: patternLabels[selectedKPIindex],
      startSelection: {
        type: selectionType(),
        name:
          selectedNodeData.clearname ||
          selectedNodeData.windowtitle ||
          getPaxbotNodeLabel(currentApp),
      },
      controls: {
        connections: napps,
        stepsBefore: levelBefore,
        stepsAfter: levelAfter,
        minimumFrequencyPercent: minFrequency,
        activeFilterCount: getApplicableFilters($damfilters[idproject]).length,
      },
      quantification: {
        transitions: formatGraphTotal(visibleGraphTotal),
        clicks: visibleGraphInteractions.mouseclicks
          ? formatCompactNumber(visibleGraphInteractions.mouseclicks)
          : "-",
        time: formatPaxbotDuration(visibleGraphInteractions.time),
      },
      globalKpis: {
        totalTime: formatPaxbotDuration(selectedNodeData.time),
        mouseclicks: formatCompactNumber(selectedNodeData.mouseclicks),
        textTime: formatPaxbotDuration(selectedNodeData.text_time),
        copyTime: formatPaxbotDuration(selectedNodeData.copy_time),
      },
      applicationShares: visibleAppShares.map((app) => ({
        name: app.clearname,
        sharePercent: Math.round(Number(app.ratio) * 100),
      })),
      visibleNodes: (displayGraph?.nodes || []).map((node) => ({
        id: node.id,
        name: node.label || normalizeGraphNodeId(node.id),
        weightedTime: formatPaxbotDuration(node.weighted_time),
        timeBefore: formatPaxbotDuration(node.weighted_time_before),
        timeAfter: formatPaxbotDuration(node.weighted_time_after),
      })),
      visibleTransitions: (displayGraph?.edges || []).map((edge) => ({
        from: getPaxbotNodeLabel(edge.from),
        to: getPaxbotNodeLabel(edge.to),
        occurrences: Number(edge.value) || 0,
      })),
      flowPath: {
        drawing: drawMode,
        selectedSavedPath: selectedDrawing
          ? {
              name: selectedDrawing.name,
              transitions: selectedDrawing.transitions.map((transition) => ({
                from: transition.fromLabel || getNodeLabel(transition.from),
                to: transition.toLabel || getNodeLabel(transition.to),
                occurrences: Number(transition.value) || 0,
              })),
            }
          : null,
        savedPathCount: scopedDrawings.length,
      },
    };
  }

  async function requestPaxbotAnswer(question, history, responseLanguage) {
    const response = await fetchWithSession("/api/damprojects/paxbot/chat", {
      signal: abortSignal,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        question,
        history: history.slice(-2),
        context: {
          ...getPaxbotContext(),
          responseLanguage,
        },
      }),
    });
    const responseText = await response.text();
    let result = {};
    try {
      result = responseText ? JSON.parse(responseText) : {};
    } catch {
      throw new Error(
        `Paxbot endpoint returned ${response.status || "an invalid response"}`,
      );
    }
    if (!response.ok || result.status === "error") {
      throw new Error(result.message || "Paxbot request failed");
    }
    return result.answer;
  }

  function getVisibleGraphInteractions(graph) {
    const visibleNodes = graph?.nodes || [];
    return visibleNodes.reduce(
      (sum, node) => {
        const item = getKpiItemForNode(node);
        const hasSplitTime =
          Object.prototype.hasOwnProperty.call(node, "weighted_time_before") ||
          Object.prototype.hasOwnProperty.call(node, "weighted_time_after");
        const visibleTime = hasSplitTime
          ? (Number(node.weighted_time_before) || 0) +
            (Number(node.weighted_time_after) || 0)
          : Number(node.weighted_time) || 0;
        return {
          time: sum.time + visibleTime,
          mouseclicks: sum.mouseclicks + (Number(item?.mouseclicks) || 0),
        };
      },
      { time: 0, mouseclicks: 0 },
    );
  }

  function getDisplayNodes(nodes) {
    return (nodes || []).map((node) => ({
      ...node,
      image: getDisplayNodeImage(node),
    }));
  }

  function getDisplayNodeImage(node) {
    const item = getKpiItemForNode(node);
    if (selectedLevel < 2) {
      return item?.applicationname
        ? `/api/damprojects/app-icon?application=${encodeURIComponent(item.applicationname)}`
        : node.image;
    }
    const appItem = applicationlist.find(
      (app) =>
        app.clearname === item?.clearname ||
        app.id === item?.clearname ||
        app.id === item?.id,
    );
    const application = appItem?.applicationname || item?.applicationname;
    return application
      ? `/api/damprojects/app-icon?application=${encodeURIComponent(application)}`
      : node.image;
  }

  function getKpiItemForNode(node) {
    const id = normalizeGraphNodeId(node.id);
    const label = node.label || id;
    return (
      windowlist.find(
        (item) =>
          item.id == id ||
          item.id == label ||
          item.windowtitle == label ||
          `${item.clearname} - ${item.windowtitle}` == label,
      ) ||
      applicationlist.find(
        (item) => item.id == id || item.clearname == label || item.id == label,
      )
    );
  }

  function delayedRequest(callback) {
    if (requestTimeout) {
      clearTimeout(requestTimeout);
    }
    requestTimeout = setTimeout(() => {
      buttonsDisabled = true;
      callback();
    }, 500);
  }

  function transformGraph(graph, levelBefore, levelAfter) {
    let transformedEdges = [];
    let connectedNodes = new Set();

    for (let i = 1; i <= levelBefore; i++) {
      let key = `Edges_${i}b`;
      if (graph.edges[key]) {
        transformedEdges.push(...graph.edges[key]);
      }
    }

    for (let i = 1; i <= levelAfter; i++) {
      let key = `Edges_${i}a`;
      if (graph.edges[key]) {
        transformedEdges.push(...graph.edges[key]);
      }
    }

    transformedEdges.forEach((edge) => {
      connectedNodes.add(edge.from);
      connectedNodes.add(edge.to);
    });

    let filteredNodes = graph.nodes.filter((node) =>
      connectedNodes.has(node.id),
    );

    return {
      nodes: filteredNodes,
      edges: transformedEdges,
    };
  }

  function getDataTable(data) {
    dataNew = [];
    from = [];
    to = ["From/to"];
    data.forEach((dataT) => {
      from.push(dataT.from);
      dataT.to.forEach((dest) => {
        if (!to.includes(dest.to)) {
          to.push(dest.to);
        }
      });
    });

    data.forEach((e) => {
      let row = [e.from];
      let number;

      for (let i = 1; i < to.length; i++) {
        number = "";
        e.to.forEach((dest) => {
          if (dest.to == to[i]) {
            number = dest.count;
          }
        });
        row.push(number);
      }
      dataNew.push(row);
    });
  }

  function getWindowPartitions() {
    windowPartitionsLoading = true;
    loadingApp = true;
    loading = true;
    const applicableFilters = getApplicableFilters($damfilters[idproject]);
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/damprojects/getWindowTitleKPIs?project_id=${idproject}&filter=${filterString}&source=${dataSource()}`,
      { signal: abortSignal },
    )
      .then((res) => res.json())
      .then((data) => {
        windowlist = data;
        windowPartitionsLoading = false;
        loading = false;
      });
    fetchWithSession(
      `/api/damprojects/getApplicationKPIs?project_id=${idproject}&filter=${filterString}&source=${dataSource()}`,
      { signal: abortSignal },
    )
      .then((res) => res.json())
      .then((data) => {
        applicationlist = data;
        windowPartitionsLoading = false;
        if (!currentApp && applicationlist.length > 0) {
          currentApp = applicationlist[0].id;
        }
        loadingApp = false;
      });
  }

  function fetchAppGraph(currentApp, options = {}) {
    const applicableFilters = getApplicableFilters($damfilters[idproject]);
    const filterString = JSON.stringify(applicableFilters);
    const mode = options.mode ?? graphMode();
    const useWindowSelection =
      options.useWindowSelection ?? usesWindowSelection();
    const stepsBefore = options.stepsBefore ?? levelBefore;
    const stepsAfter = options.stepsAfter ?? levelAfter;
    const analysisMode =
      selectedKPIindex === 1
        ? "pattern_split"
        : selectedKPIindex === 2
          ? "pattern_combined"
          : "flow";
    const url =
      `/api/damprojects/getSoftwareEnvironment?project_id=${idproject}&napps=${napps}&stepsBefore=${stepsBefore}&stepsAfter=${stepsAfter}` +
      (useWindowSelection
        ? `&partitionlabel=` + currentApp
        : `&applicationname=` + currentApp) +
      (mode ? `&mode=${mode}` : "") +
      `&analysisMode=${analysisMode}` +
      `&source=${dataSource()}` +
      `&filter=${filterString}`;
    if (appGraphCache.has(url)) return Promise.resolve(appGraphCache.get(url));
    if (appGraphRequests.has(url)) return appGraphRequests.get(url);
    const graphRequest = fetchWithSession(url, { signal: abortSignal })
      .then((response) => response.json())
      .then((data) => {
        appGraphCache.set(url, data);
        return data;
      })
      .finally(() => appGraphRequests.delete(url));
    appGraphRequests.set(url, graphRequest);
    return graphRequest;
  }

  async function prefetchDrawGraphs(sourceGraph) {
    if (selectedKPIindex !== 0 || drawMode || drawingViewMode) return;
    const center = normalizeGraphNodeId(currentApp);
    const nodes = (sourceGraph?.nodes || [])
      .filter((node) => normalizeGraphNodeId(node.id) !== center)
      .slice(0, 8);
    for (const node of nodes) {
      const nodeId = String(node.id || "");
      const steps = nodeId.includes("###n")
        ? { stepsBefore: 0, stepsAfter: 1 }
        : nodeId.includes("###p")
          ? { stepsBefore: 1, stepsAfter: 0 }
          : { stepsBefore: 1, stepsAfter: 1 };
      try {
        await fetchAppGraph(normalizeGraphNodeId(nodeId), {
          ...steps,
          ...drawFetchOptionsForNode(nodeId),
        });
      } catch {
        break;
      }
    }
  }

  function loadAppGraph(currentApp) {
    appGraphLoading = true;
    fetchAppGraph(currentApp).then((data) => {
      graph = data;
      prefetchDrawGraphs(data);
      appGraphLoading = false;
      buttonsDisabled = false;
    });
  }

  function increment(i) {
    return i + 1;
  }

  function decrement(i) {
    if (i > 1) {
      return i - 1;
    } else {
      return i;
    }
  }
</script>

<Breakpoint on:change={(e) => (screenSize = e.detail.breakpointValue)} />

<Header
  paddingRight={false}
  section="Workflow Analysis"
  area="Usage Analysis"
  breadcrumb="App Flow"
  tooltipText="The App Flow shows how applications and windows are connected through user interactions."
>
  <AppDrilldownSourceMenu bind:selected={selectedSourceIndex} />
  <Filter />
</Header>

<SectionWrapper
  fullscreen={fullscreen && !noDataForFilters}
  fitScreen={true}
  loading={loading || loadingApp || appGraphLoading}
  loadingTitle="Loading application flow data."
  loadingHint="Please wait while App Flow is prepared."
  emptyState={noDataForFilters}
>
  <div slot="main" class="main_wapper">
    <PaxbotChat
      bind:open={paxbotOpen}
      heading="Pax AI"
      subheading="App Flow Assistant"
      starterQuestions={paxbotStarterQuestions}
      requestAnswer={requestPaxbotAnswer}
    />
    {#if selectMode === 0}
      <div class="menu_overlay">
        <div class="buttons_wrapper">
          <OverflowMenu style="width: auto;">
            <div slot="menu">
              <Button
                icon={selectedLevel === 0
                  ? APPLICATIONS_ICON
                  : selectedLevel <= 2
                    ? APPOVERVIEW_ICON
                    : WINDOWS_ICON}
                iconDescription={levelLabels[selectedLevel]}
                kind="secondary"
              />
            </div>
            <OverflowMenuItem
              text="Application Map"
              on:click={() => {
                selectedLevel = 0;
                currentApp = applicationlist[0].id;
              }}
              primaryFocus={selectedLevel === 0}
            />
            <OverflowMenuItem
              text="App Inflow"
              disabled={windowTitlesLocked}
              on:click={() => {
                selectedLevel = 1;
                currentApp = applicationlist[0].id;
              }}
              primaryFocus={selectedLevel === 1}
            />
            <OverflowMenuItem
              text="App Outflow"
              disabled={windowTitlesLocked}
              on:click={() => {
                selectedLevel = 2;
                currentApp = windowlist[0].id;
              }}
              primaryFocus={selectedLevel === 2}
            />
            <OverflowMenuItem
              text="Window Map"
              disabled={windowTitlesLocked}
              on:click={() => {
                selectedLevel = 3;
                currentApp = windowlist[0].id;
              }}
              primaryFocus={selectedLevel === 3}
            />
          </OverflowMenu>
          <OverflowMenu style="width: auto;">
            <div slot="menu">
              <Button
                kind="secondary"
                icon={selectedKPIindex === 0
                  ? INTERACTIONS_ICON
                  : TIME_BEFORE_ICON}
                iconDescription={patternLabels[selectedKPIindex]}
              />
            </div>
            <OverflowMenuItem
              text="Transition Pattern"
              on:click={() => (selectedKPIindex = 0)}
              primaryFocus={selectedKPIindex === 0}
            />
            <OverflowMenuItem
              text="Split Pattern"
              on:click={() => (selectedKPIindex = 1)}
              primaryFocus={selectedKPIindex === 1}
            />
            <OverflowMenuItem
              text="Combined Pattern"
              on:click={() => (selectedKPIindex = 2)}
              primaryFocus={selectedKPIindex === 2}
            />
          </OverflowMenu>
        </div>
        <div class="buttons_wrapper">
          <Button
            kind="secondary"
            icon={drawMode ? SAVE_ICON : ADD_ROAD_ICON}
            iconDescription={drawMode ? "Save flow path" : "Draw flow path"}
            on:click={toggleDrawing}
          />
          <Button
            kind={paxbotOpen ? "primary" : "secondary"}
            icon={BOT_WHITE_ICON}
            iconDescription="Open Pax AI"
            on:click={() => (paxbotOpen = !paxbotOpen)}
          />
        </div>
      </div>
    {/if}
    <div class="graph_info_overlay">
      <section class="info_card">
        <button
          class="info_header"
          on:click={() => (quantificationOpen = !quantificationOpen)}
        >
          <span>Quantification</span>
          <svg
            class="arrow"
            height="0.5rem"
            viewBox="0 0 17 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {#if quantificationOpen}
              <path
                d="M8.5 9.36707e-05L17 8.50009L16.11 9.39014L8.5 1.77093L0.890041 9.38089L7.86186e-08 8.49084L8.5 9.36707e-05Z"
                fill="currentColor"
              />
            {:else}
              <path
                d="M8.5 9.39004L0 0.890042L0.890045 0L8.5 7.6192L16.11 0.00924664L17 0.899292L8.5 9.39004Z"
                fill="currentColor"
              />
            {/if}
          </svg>
        </button>
        {#if quantificationOpen}
          <div class="quant_summary">
            <div>
              <strong>
                {(selectedLevel ? loading : loadingApp)
                  ? "..."
                  : formatGraphTotal(visibleGraphTotal)}
              </strong>
              <span>Transitions</span>
            </div>
            <div>
              <strong>
                {(selectedLevel ? loading : loadingApp)
                  ? "..."
                  : visibleGraphInteractions.mouseclicks
                    ? formatCompactNumber(visibleGraphInteractions.mouseclicks)
                    : "-"}
              </strong>
              <span>Clicks</span>
            </div>
            <div>
              <strong>
                {(selectedLevel ? loading : loadingApp)
                  ? "..."
                  : visibleGraphInteractions.time
                    ? formatTimeDelta(visibleGraphInteractions.time)
                    : "-"}
              </strong>
              <span>Time</span>
            </div>
          </div>
        {/if}
      </section>
      <section class="info_card">
        <button
          class="info_header"
          on:click={() => (applicationsOpen = !applicationsOpen)}
        >
          <span>Applications</span>
          <svg
            class="arrow"
            height="0.5rem"
            viewBox="0 0 17 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {#if applicationsOpen}
              <path
                d="M8.5 9.36707e-05L17 8.50009L16.11 9.39014L8.5 1.77093L0.890041 9.38089L7.86186e-08 8.49084L8.5 9.36707e-05Z"
                fill="currentColor"
              />
            {:else}
              <path
                d="M8.5 9.39004L0 0.890042L0.890045 0L8.5 7.6192L16.11 0.00924664L17 0.899292L8.5 9.39004Z"
                fill="currentColor"
              />
            {/if}
          </svg>
        </button>
        {#if applicationsOpen}
          <div class="app_list">
            {#each visibleAppShares as app}
              <div class="app_row">
                <span>{app.clearname}</span>
                <span class="app_bar">
                  <span
                    style={`width: ${Math.round(Number(app.ratio) * 100)}%;`}
                  ></span>
                </span>
                <strong>{Math.round(Number(app.ratio) * 100)}%</strong>
              </div>
            {/each}
          </div>
        {/if}
      </section>
    </div>
    <div class="canvas">
      <div class="ui_viewer_wrapper">
        {#if appGraphLoading}
          <div class="loading_wrapper">
            <Loading withOverlay={false} />
          </div>
        {:else if selectMode === 0}
          <FlowPlotterSmall
            dottedBackground
            bind:this={flowPlotterRef}
            nodes={getDisplayNodes(displayGraph["nodes"])}
            edges={displayGraph["edges"]}
            width="100%"
            height="100%"
            formatEdges={(e) => {
              return e;
            }}
            formatNodeMetric={formatTimeDelta}
            bind:selectedNode={currentApp}
            bind:zoomLevel
            {drawMode}
            confirmedNodeIds={drawConfirmedNodes}
            confirmedEdgeKeys={drawConfirmedEdges}
            candidateNodeIds={drawCandidateNodes}
            candidateEdgeKeys={drawCandidateEdges.map(edgeKey)}
            drawStartNodeId={drawStartNode}
            on:nodeclick={handleDrawNodeClick}
            on:nodedelete={handleDrawNodeDelete}
          />
        {:else}
          <div class="table-container">
            <MatrixTable header={to} rows={dataNew} loading={appGraphLoading}
            ></MatrixTable>
          </div>
        {/if}
      </div>
    </div>
    <div class="menu_overlay bottom">
      <div class="buttons_wrapper">
        <Button
          kind="plus-minus"
          defaultValue={1}
          text={screenSize >= 1584 ? "Connections" : "C"}
          bind:value={napps}
          unit=""
          increment={(i) => increment(i)}
          decrement={(i) => decrement(i)}
          disabled={buttonsDisabled}
        />
        <Button
          kind="plus-minus"
          defaultValue={1}
          text={screenSize >= 1584 ? "Steps before" : "SB"}
          bind:value={levelBefore}
          unit=""
          increment={(i) => increment(i)}
          decrement={(i) => Math.max(0, (Number(i) || 0) - 1)}
          minValue={0}
          disabled={buttonsDisabled || drawMode}
        />
        <Button
          kind="plus-minus"
          defaultValue={1}
          text={screenSize >= 1584 ? "Steps after" : "SA"}
          bind:value={levelAfter}
          unit=""
          increment={(i) => increment(i)}
          decrement={(i) => Math.max(0, (Number(i) || 0) - 1)}
          minValue={0}
          disabled={buttonsDisabled || drawMode}
        />
        <Button
          kind="plus-minus"
          defaultValue={0}
          text={screenSize >= 1584 ? "Min. Freq" : "MF"}
          bind:value={minFrequency}
          unit="%"
          increment={(i) => Math.min(100, (Number(i) || 0) + 5)}
          decrement={(i) => Math.max(0, (Number(i) || 0) - 5)}
          minValue={0}
          maxValue={100}
          disabled={buttonsDisabled}
        />
      </div>
      <div class="buttons_wrapper">
        <Button
          kind="plus-minus"
          text={screenSize >= 1584 ? "Zoom" : "Z"}
          showValue={false}
          bind:value={zoomLevel}
        />
        <!-- Temporarily disabled: download export needs to be fixed later. -->
        <!-- <Button kind="secondary"icon={DOWNLOAD_ICON} on:click={handleDownload} /> -->

        <Button
          kind="secondary"
          icon={fullscreen ? FULLSCREEN_OFF_ICON : FULLSCREEN_ICON}
          on:click={() => {
            fullscreen = !fullscreen;
          }}
        />
      </div>
    </div>
  </div>

  <div slot="emptyState" class="empty_state_text">
    <div class="empty_state_title">
      No data is available for this view with the selected filters.
    </div>
    <div class="empty_state_hint">
      Remove or adjust the filters to update the results.
    </div>
  </div>

  <div class="menu" slot="menu">
    <Accordion heading="Start Selection" open={true}>
      <AppSelection
        appData={usesWindowSelection() ? windowlist : applicationlist}
        enableDeselection={false}
        bind:currentApp
        bind:selectedLevel
        searchPlaceholder={`Search for ${selectionType()}`}
        windowSelectionEnabled={false}
        disableBelowOnePercent={true}
        showKpiSummary
        readableDuration
        loading={usesWindowSelection() ? loading : loadingApp}
      />
    </Accordion>
    <Accordion heading="Saved Flow Paths" open={false}>
      <div class="drawings_panel">
        {#if scopedDrawings.length > 0}
          <div class="drawing_search">
            <input
              type="text"
              bind:value={drawingSearchTerm}
              placeholder="Search saved flow paths"
            />
          </div>
        {/if}
        {#if visibleDrawings.length === 0}
          <div class="empty_drawings">
            {scopedDrawings.length === 0
              ? "No flow paths saved"
              : "No matching flow paths"}
          </div>
        {:else}
          {#each pagedDrawings as drawing}
            <div
              class="drawing_row"
              class:drawing_row_selected={selectedDrawingId === drawing.id}
              role="button"
              tabindex="0"
              on:click={() => loadDrawing(drawing)}
              on:keydown={(event) => {
                if (event.key === "Enter" || event.key === " ")
                  loadDrawing(drawing);
              }}
            >
              {#if editingDrawingId === drawing.id}
                <input
                  bind:value={editingDrawingName}
                  on:click|stopPropagation
                  on:keydown|stopPropagation={(event) => {
                    if (event.key === "Enter") saveRenameDrawing(drawing);
                    if (event.key === "Escape") editingDrawingId = "";
                  }}
                />
              {:else}
                <strong>{drawing.name}</strong>
              {/if}
              <span>{drawing.transitions.length} transitions</span>
              <button
                class="drawing_icon_button"
                on:click|stopPropagation={() =>
                  editingDrawingId === drawing.id
                    ? saveRenameDrawing(drawing)
                    : startRenameDrawing(drawing)}
              >
                <span
                  class="drawing_icon"
                  style={`--icon-url: url(${
                    editingDrawingId === drawing.id
                      ? "/img/assistant/icons/save.svg"
                      : "/img/assistant/icons/edit.svg"
                  });`}
                ></span>
              </button>
              <button
                class="drawing_icon_button"
                on:click|stopPropagation={() => openDeleteDrawingModal(drawing)}
              >
                <span
                  class="drawing_icon"
                  style="--icon-url: url(/img/assistant/icons/trash.svg);"
                ></span>
              </button>
            </div>
          {/each}
          <div class="drawing_pagination">
            <button
              disabled={drawingsPage === 0}
              on:click={() => (drawingsPage = Math.max(0, drawingsPage - 1))}
            >
              &lt;
            </button>
            <span>{drawingsPage + 1} - {drawingsPages}</span>
            <button
              disabled={drawingsPage + 1 >= drawingsPages}
              on:click={() =>
                (drawingsPage = Math.min(drawingsPages - 1, drawingsPage + 1))}
            >
              &gt;
            </button>
          </div>
        {/if}
      </div>
    </Accordion>
  </div>
</SectionWrapper>

<DangerModal
  size="sm"
  bind:open={saveDrawingModalOpen}
  modalHeading="Save Flow Path"
  primaryButtonText="Save Flow Path"
  secondaryButtonText="Cancel"
  preventCloseOnClickOutside
  on:submit={confirmSaveDrawing}
  on:click:button--secondary={() => (saveDrawingModalOpen = false)}
  on:close={() => (saveDrawingModalOpen = false)}
>
  <TextInput
    labelText="Name"
    bind:value={pendingDrawingName}
    placeholder="Flow Path name"
  />
</DangerModal>

<DangerModal
  danger
  bind:open={deleteDrawingModalOpen}
  modalHeading="Delete Flow Path"
  primaryButtonText="Delete Flow Path"
  secondaryButtonText="Cancel"
  preventCloseOnClickOutside
  on:click:button--primary={confirmDeleteDrawing}
  on:click:button--secondary={() => {
    deleteDrawingModalOpen = false;
    drawingToDelete = null;
  }}
  on:close={() => {
    deleteDrawingModalOpen = false;
    drawingToDelete = null;
  }}
>
  <p class="delete_drawing_body">
    Are you sure you want to delete this flow path?
    {#if drawingToDelete?.name}
      <span>{drawingToDelete.name}</span>
    {/if}
  </p>
</DangerModal>

<style>
  .main_wapper {
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .empty_state_title,
  .empty_state_hint {
    font-size: 1rem;
    line-height: 1.25rem;
  }

  .empty_state_title {
    color: var(--pax-black);
  }

  .empty_state_hint {
    color: var(--pax-grey);
    margin-top: 0.5rem;
  }

  .main_wapper :global(.paxbot_chat_window) {
    bottom: 5.85rem !important;
    position: absolute !important;
    right: 1rem !important;
    z-index: 50 !important;
  }

  .main_wapper :global(.paxbot_chat_mascot) {
    bottom: -0.65rem !important;
    position: absolute !important;
    right: 1.55rem !important;
    z-index: 51 !important;
  }

  .menu_overlay {
    position: absolute;
    width: 100%;
    z-index: 4;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .menu_overlay :global(.bx--overflow-menu-options) {
    z-index: 10;
  }

  .bottom {
    bottom: 0;
  }

  .graph_info_overlay {
    position: absolute;
    top: 4rem;
    left: 0;
    z-index: 2;
    width: 18rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .info_card {
    border: 1px solid #e3e6ea;
    border-radius: 0.5rem;
    background: rgba(255, 255, 255, 0.95);
    overflow: hidden;
  }

  .info_header {
    width: 100%;
    min-height: 3.25rem;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 0.5rem;
    padding: 0 1rem;
    border: 0;
    border-bottom: 1px solid #e8e8e8;
    background: transparent;
    color: var(--pax-black);
    font-weight: 700;
    cursor: pointer;
    text-align: left;
  }

  .quant_summary {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.25rem;
    padding: 0.9rem 0.75rem;
  }

  .quant_summary div {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    text-align: center;
  }

  .quant_summary strong {
    font-size: 1rem;
    line-height: 1;
  }

  .quant_summary span {
    color: #5f6770;
    font-size: 0.75rem;
  }

  .app_list {
    display: flex;
    flex-direction: column;
    gap: 0.9rem;
    padding: 1rem;
  }

  .app_row {
    display: grid;
    grid-template-columns: 4.9rem 1fr 2.1rem;
    align-items: center;
    gap: 0.55rem;
    font-size: 0.75rem;
  }

  .app_bar {
    height: 0.18rem;
    border-radius: 99px;
    background: #e3e5e8;
    overflow: hidden;
  }

  .app_bar span {
    display: block;
    height: 100%;
    background: #ff5a1f;
  }

  .canvas {
    height: calc(100% - 110px);
    width: 100%;
    z-index: 0; /* Platziert das Canvas hinter den Overlays */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .buttons_wrapper {
    display: flex;
    gap: 0.5rem;
    user-select: none;
  }

  .menu {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .drawings_panel {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .drawing_search {
    display: flex;
    align-items: center;
    height: 3rem;
    padding: 0 1rem;
    border: 1px solid var(--pax-black);
    border-radius: 0.5rem;
  }

  .drawing_search input {
    width: 100%;
    border: 0;
    font: inherit;
    outline: none;
  }

  .empty_drawings {
    padding: 0.75rem;
    color: #5f6770;
    font-size: 0.875rem;
  }

  .drawing_row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto 2rem 2rem;
    gap: 0.75rem;
    align-items: center;
    width: 100%;
    padding: 0.75rem;
    border: 0;
    border-radius: 0.5rem;
    background: #f2f2f2;
    cursor: pointer;
    text-align: left;
  }

  .drawing_row:hover {
    outline: 1px solid var(--pax-orange);
  }

  .drawing_row_selected {
    outline: 1px solid var(--pax-orange);
    background: #fff4ee;
  }

  .drawing_row input {
    min-width: 0;
    border: 0;
    background: transparent;
    font: inherit;
    font-weight: 600;
  }

  .drawing_row strong {
    min-width: 0;
    overflow: hidden;
    font: inherit;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .drawing_row span {
    color: #5f6770;
    font-size: 0.75rem;
  }

  .drawing_icon_button {
    display: flex;
    width: 2rem;
    height: 2rem;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 0.35rem;
    background: transparent;
    cursor: pointer;
  }

  .drawing_icon_button:hover {
    background: #2a2a2f;
  }

  .drawing_icon {
    width: 1rem;
    height: 1rem;
    background: var(--pax-black);
    mask: var(--icon-url) center / contain no-repeat;
    -webkit-mask: var(--icon-url) center / contain no-repeat;
  }

  .drawing_icon_button:hover .drawing_icon {
    background: var(--pax-white);
  }

  .drawing_pagination {
    display: grid;
    grid-template-columns: 2.75rem 1fr 2.75rem;
    gap: 0.5rem;
    align-items: center;
    padding-top: 0.5rem;
  }

  .drawing_pagination button {
    height: 2.75rem;
    border: 0;
    border-radius: 0.5rem;
    background: var(--pax-black);
    color: var(--pax-white);
    cursor: pointer;
  }

  .drawing_pagination button:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }

  .drawing_pagination span {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2.75rem;
    border-radius: 0.5rem;
    background: #f2f2f2;
    font-weight: 600;
  }

  .delete_drawing_body {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    color: var(--pax-black);
    font-size: 0.875rem;
  }

  .delete_drawing_body span {
    font-weight: 700;
  }

  .ui_viewer_wrapper {
    height: 100%;
    width: 100%;
  }

  .loading_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 100%;
  }

  @media screen and (max-width: 1900px) {
    .menu_overlay {
      font-size: 0.7rem;
    }
  }
  @media screen and (max-width: 1690px) {
    .menu_overlay {
      font-size: 0.6rem;
    }
  }
</style>
